import {
    AwardsBlock,
    Breadcrumb,
    ContactsBlock,
    CrewMembersBlock,
    DegustationBlock,
    FAQsBlock,
    Footer,
    Header,
    ImagesBlock,
    NavigationBlock,
    PlacesBlock,
    PortfolioBlock,
    Toolbar,
} from 'widgets';
// eslint-disable-next-line no-restricted-imports
import React, { memo, useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispath, PageLayout, Error } from 'shared';
import { CateringFormatPageActions, useCateringFormatPageState } from '../store';
import { CateringFormatMain } from './components';

const MemoBreadcrumb = memo(Breadcrumb);
const MemoFooter = memo(Footer);
const MemoAwardsBlock = memo(AwardsBlock);
const MemoPortfolioBlock = memo(PortfolioBlock);
const MemoPlacesBlock = memo(PlacesBlock);
const MemoFAQsBlock = memo(FAQsBlock);
const MemoDegustationBlock = memo(DegustationBlock);
const MemoImagesBlock = memo(ImagesBlock);
const MemoContactsBlock = memo(ContactsBlock);
const MemoNavigationBlock = memo(NavigationBlock);
const MemoMain = CateringFormatMain;

export const CateringFormatPage = () => {
    const { slug } = useParams();
    const dispatch = useAppDispath();
    const { cateringFormat, errors } = useCateringFormatPageState();

    useLayoutEffect(() => {
        if (slug) dispatch(CateringFormatPageActions.getCateringFormatBySlug({ slug }));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [slug]);

    return (
        <PageLayout
            toolbar={<Toolbar />}
        >
            <Header />
            <MemoBreadcrumb />
            {errors.length === 0 ? (
                <MemoMain
                    cateringFormat={cateringFormat}
                />
            ) : (
                <Error
                    errors={errors}
                    margin="4rem 0"
                />
            )}
            <MemoAwardsBlock />
            <MemoImagesBlock />
            <MemoDegustationBlock />
            <CrewMembersBlock />
            <MemoPortfolioBlock />
            <MemoPlacesBlock />
            <MemoContactsBlock />
            <MemoFAQsBlock />
            <MemoNavigationBlock />
            <MemoFooter />
        </PageLayout>
    );
};
